/*!jslint this */
jQuery(function ($) {
  "use strict";

  function initAOS() {
    AOS.init({
      easing: "ease-in-out-sine",
      duration: 400,
      once: true,
    });
  }

  function setAppHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
  }

  setTimeout(setAppHeight, 100);
  $(window).on("resize", setAppHeight);
  initAOS();

  $(document).on("click", ".nav-toggle", function (e) {
    $("html").toggleClass("nav-open");
  });

  $(".home-concierge-cl").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: true,
    nextArrow:
      '<span class="slick-next"><svg width="0.625rem" height="1.125rem" viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><path xmlns="http://www.w3.org/2000/svg" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.875" d="M0 0L7.588 7.588 0 15.175" transform="translate(1.413 1)"/></svg></span>',
    prevArrow:
      '<span class="slick-prev"><svg width="0.625rem" height="1.125rem" viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><path xmlns="http://www.w3.org/2000/svg" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.875" d="M7.588 0L0 7.588 7.588 15.175" transform="translate(1 1)"/></svg></span>',
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        },
      },
    ],
  });

  $(".home-trips-cl").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    dots: true,
    nextArrow:
      '<span class="slick-next"><svg width="0.75rem" height="0.8125rem" viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip0_2143_3480)"><path stroke-linecap="round" stroke-linejoin="round" d="M11.6216 6.81738H0.378582"/><path stroke-linecap="round" stroke-linejoin="round" d="M5.62836 1.31738L11.4499 6.44188C11.5031 6.4888 11.5457 6.54651 11.5749 6.61116C11.604 6.67582 11.6191 6.74594 11.6191 6.81688C11.6191 6.88782 11.604 6.95795 11.5749 7.0226C11.5457 7.08726 11.5031 7.14496 11.4499 7.19188L5.62836 12.3174"/></g><defs xmlns="http://www.w3.org/2000/svg"><clipPath id="clip0_2143_3480"><path fill="white" d="M0 0H12V12H0z" transform="matrix(-1 0 0 1 12 .817)"/></clipPath></defs></svg></span>',
    prevArrow:
      '<span class="slick-prev"><svg width="0.75rem" height="0.8125rem" viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip0_2143_3470)"><path stroke-linecap="round" stroke-linejoin="round" d="M0.378418 6.81738H11.6214"/><path stroke-linecap="round" stroke-linejoin="round" d="M6.37164 1.31738L0.55014 6.44188C0.496937 6.4888 0.454327 6.54651 0.42514 6.61116C0.395954 6.67582 0.380859 6.74594 0.380859 6.81688C0.380859 6.88782 0.395954 6.95795 0.42514 7.0226C0.454327 7.08726 0.496937 7.14496 0.55014 7.19188L6.37164 12.3174"/></g><defs xmlns="http://www.w3.org/2000/svg"><clipPath id="clip0_2143_3470"><path fill="white" d="M0 0H12V12H0z" transform="translate(0 .817)"/></clipPath></defs></svg></span>',
    appendArrows: $(".home-trips-cl-nav"),
    appendDots: $(".home-trips-cl-dots"),
    customPaging: function (slider, i) {
      return "<button>" + (i + 1) + "</button>";
    },
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(document).on("click", ".tab-list a", function (e) {
    e.preventDefault();
    $(".tab-list a").removeClass("active");
    $(this).addClass("active");
    var currentTab = $(this).attr("href");
    $(".tab-item").removeClass("active");
    $(currentTab).addClass("active");
    return false;
  });
  $(document).on("change", ".tab-list-select", function (e) {
    var currentTab = $(this).val();
    $(".tab-item").removeClass("active");
    $(currentTab).addClass("active");
  });

  $(document).on("click", ".event-popup", function (e) {
    e.preventDefault();

    const url = $(this).attr("href");
    const $popupLoader = $("#event-popup-loader");

    if (!url) return;

    $("html").addClass("popup-open");
    $popupLoader.addClass("active loading");

    $popupLoader.load(url, function (response, status, xhr) {
      $popupLoader.removeClass("loading");

      if (status === "error") {
        console.error("Error loading popup:", xhr.status, xhr.statusText);
        $popupLoader.html(
          '<p class="error-message">Failed to load content. Please try again later.</p>'
        );
      }
    });
  });
  $(document).on("click", ".popup-toggle", function (e) {
    e.preventDefault();
     $("html").addClass("search-open");
   });

     $(document).on("click", ".month-popup-tgr", function (e) {
    e.preventDefault();
     $("html").addClass("mf-open");
   });


  $(document).on("click", ".popup-close", function (e) {
    e.preventDefault();
    $("#event-popup-loader").removeClass("active");
    $("html").removeClass("popup-open");
  });
  $(document).on("click", ".search-close", function (e) {
    e.preventDefault();
    $("html").removeClass("search-open");
  });

    $(document).on("click", ".mf-close", function (e) {
    e.preventDefault();
    $("html").removeClass("mf-open");
  });
  
  $(document).on("click", ".event-popup-loader", function (e) {
    if (!$(e.target).closest(".event-popup-main").length) {
      $("#event-popup-loader").removeClass("active");
      $("html").removeClass("popup-open");
    }
  });
  $(document).on("click", ".share-btn", function (e) {
    e.preventDefault();
    const url = $(this).attr("data-url");
    const $btn = $(this);

    navigator.clipboard
      .writeText(url)
      .then(function () {
        const $msg = $(
          '<span class="share-success">URL successfully copied!</span>'
        );
        $btn.append($msg);

        setTimeout(function () {
          $msg.remove();
        }, 3000);
      })
      .catch(function (err) {
        console.error("Failed to copy: ", err);
      });
  });

  $(document).on("click", ".loadmore", function (e) {
    e.preventDefault();
    var $el = $(this),
      $tgt = $el.data("target"),
      link = $el.attr("href");
    if ($el.attr("disabled")) return;
    $el.addClass("loading").attr("disabled", true);
    $el.find("span").html("Loading...");
    $("<div>").load(link + $tgt, function () {
      $($tgt).append($(this).find($tgt).html());
      $el.parents(".load-more").removeAttr("disabled").remove();
    });
  });
  $(".cs-select").selectric({
    arrowButtonMarkup: '<span class="arr"></span>',
    maxHeight: 500,
  });

  document.querySelectorAll("dotlottie-player").forEach(function (player) {
    const delay = parseInt(player.getAttribute("data-delay"), 10) || 0;

    player.addEventListener("ready", function () {
      setTimeout(() => {
        player.play();
      }, delay);
    });
  });


  function updateSelectricWidths() {
    $(".sb-item .selectric-cs-select").each(function () {
      const $container = $(this);
      let maxWidthPx = 0;
      let longestText = "";

      // Step 1: Find max width of list items
      $container.find("ul li").each(function () {
        const $item = $(this);
        const span = $("<span>")
          .text($item.text())
          .css({
            position: "absolute",
            visibility: "hidden",
            whiteSpace: "nowrap",
            font: $item.css("font"),
          })
          .appendTo("body");

        const textWidth = span.width();
        span.remove();
        const paddingLeft = parseFloat($item.css("padding-left")) || 0;
        const paddingRight = parseFloat($item.css("padding-right")) || 0;

        const totalWidth = textWidth + paddingLeft + paddingRight + 15;
        if (totalWidth > maxWidthPx) {
          maxWidthPx = totalWidth;
          longestText = $item.text();
        }
      });

      const maxWidthRem = maxWidthPx / 16;
      $container.css("min-width", maxWidthPx + "px");

      // Step 2: Calculate margin-right for .selectric
      const $select = $container.find("select");
      const selectedText = $select.find("option:selected").text();

      const $selectric = $container.find(".selectric");
      const paddingLeft = parseFloat($selectric.css("padding-left")) || 0;
      const paddingRight = parseFloat($selectric.css("padding-right")) || 0;
      const $label = $selectric.find(".label");
      const $arr = $selectric.find(".arr");
      const labelWidth = $label.outerWidth() || 0;
      const arrWidth = $arr.outerWidth() || 0;

      const totalOffset =
        paddingLeft + paddingRight + labelWidth + arrWidth + 4;
      const totalOffsetRem = maxWidthPx - totalOffset;

      if (selectedText !== longestText) {
        $container.css("margin-right", `-${totalOffsetRem}px`);
      } else {
        $container.css("margin-right", "0");
      }
    });
  }

  // Initial run
  updateSelectricWidths();

  // Update on window resize
  $(window).on("resize", function () {
    updateSelectricWidths();
  });

  // On select change — only update margin-right
  $(document).on("change", ".sb-item .selectric-cs-select select", function () {
    const $select = $(this);
    const $container = $select.closest(".selectric-cs-select");
    const $selectric = $select
      .parents(".selectric-hide-select")
      .next(".selectric");
    const $label = $selectric.find(".label");
    const $arr = $selectric.find(".arr");

    let maxWidthPx = 0;
    let longestText = "";

    // Recalculate max width from list items
    $container.find("ul li").each(function () {
      const $item = $(this);
      const span = $("<span>")
        .text($item.text())
        .css({
          position: "absolute",
          visibility: "hidden",
          whiteSpace: "nowrap",
          font: $item.css("font"),
        })
        .appendTo("body");

      const textWidth = span.width();
      span.remove();

      const paddingLeft = parseFloat($item.css("padding-left")) || 0;
      const paddingRight = parseFloat($item.css("padding-right")) || 0;

      const totalWidth = textWidth + paddingLeft + paddingRight + 10;
      if (totalWidth > maxWidthPx) {
        maxWidthPx = totalWidth;
        longestText = $item.text();
      }
    });

    const selectedText = $select.find("option:selected").text();
    const paddingLeft = parseFloat($selectric.css("padding-left")) || 0;
    const paddingRight = parseFloat($selectric.css("padding-right")) || 0;
    const labelWidth = $label.outerWidth() || 0;
    const arrWidth = $arr.outerWidth() || 0;

    const totalOffset = paddingLeft + paddingRight + labelWidth + arrWidth + 4;
    const totalOffsetRem = maxWidthPx - totalOffset;

    if (selectedText !== longestText) {
      $container.css("margin-right", `-${totalOffsetRem}px`);
    } else {
      $container.css("margin-right", "0");
    }
  });

  $(".filter-wrap select").on("change", function () {
    const formData = $("#mpd-filter-form").serialize();
    const actionUrl = $("#mpd-filter-form").attr("action");
    const selectedCat = $("#mpd-cat").val();
    $(".filter-loader").addClass("loading");
    const mapViewLink = $(".venue-nav-map-item");
    const listViewLink = $(".venue-nav-list-item");
    if (mapViewLink.length) {
      const mapViewBase = mapViewLink.attr("href").split("?")[0];
      const listViewBase = listViewLink.attr("href").split("?")[0];

      const queryString =
        selectedCat && selectedCat !== "0"
          ? `?mpd-cat=${encodeURIComponent(selectedCat)}`
          : "";

      mapViewLink.attr("href", mapViewBase + queryString);
      listViewLink.attr("href", listViewBase + queryString);
    }

    if ($("#map-view").length && typeof updateMapMarkers === "function") {
      $.get(`${actionUrl}?${formData}`, function (response) {
        $(".filter-loader").removeClass("loading");

        const mapDataText = $(response).find("#map-data").text();
        try {
          const mapData = JSON.parse(mapDataText);
          updateMapMarkers(mapData, selectedCat === "0");
        } catch (e) {
          console.error("Failed to parse map data:", e);
        }
      });
    } else {
      $("<div>").load(`${actionUrl}?${formData} #card-container`, function () {
        const newContent = $(this).find("#card-container").html();
        $("#card-container").html(newContent);
        $(".filter-loader").removeClass("loading");
        console.log(`${actionUrl}?${formData}`);
      });
    }
  });
  $(document).on("click", ".go-back a", function (e) {
    e.preventDefault();
    var $url = $(this).attr("href");
    if (document.referrer && document.referrer !== window.location.href) {
      window.history.back();
    } else {
      window.location.href = $url;
    }
  });

  $(document).on("click", ".faq-list-tab-head", function (e) {
    $(".faq-list-tab").removeClass("active");
    $(".faq-list-tab-cnt").slideUp("normal");
    if ($(this).next().is(":hidden") == true) {
      $(this).parent().addClass("active");
      $(this).next().slideDown("normal");
    }
  });

  $(document).on("click", ".exp-toggle", function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    var $ul = $(this).closest("ul.card-dtls-cat");
    var $hiddenItems = $ul.find("li.hidden-term");
    var $span = $(this).find("span");

    if ($hiddenItems.is(":visible")) {
      $hiddenItems.fadeOut("fast");
      $span.text("Expand");
    } else {
      $hiddenItems.css("display", "flex").hide().fadeIn("fast");
      $span.text("Collapse");
    }
  });


  $(" .month-popup-cl").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    nextArrow:
      '<span class="slick-next"><svg width="0.5625rem" height="0.875rem" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.091" d="M1.4646 1L7.81533 6.59036C7.87337 6.64155 7.91985 6.7045 7.95169 6.77503C7.98353 6.84557 8 6.92207 8 6.99945C8 7.07684 7.98353 7.15334 7.95169 7.22388C7.91985 7.29441 7.87337 7.35736 7.81533 7.40855L1.4646 13"/></svg></svg></span>',
    prevArrow:
      '<span class="slick-prev"><svg width="0.5625rem" height="0.875rem" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.091" d="M7.5354 1L1.18467 6.59036C1.12663 6.64155 1.08015 6.7045 1.04831 6.77503C1.01647 6.84557 1 6.92207 1 6.99945C1 7.07684 1.01647 7.15334 1.04831 7.22388C1.08015 7.29441 1.12663 7.35736 1.18467 7.40855L7.5354 13"/></svg></span>',
    //appendArrows: $(".home-trips-cl-nav"),

  });
  $('#venue-search').on('keyup', function(){
        let query = $(this).val();

        if(query.length < 2){
            $('#venue-results').empty();
            return;
        }

        $.ajax({
            url: ajaxurl, // WP provides this global in admin, but on frontend we pass it manually (see below)
            data: {
                action: 'venue_autocomplete',
                q: query
            },
            success: function(data){
                let list = '';
                if(data.length){
                    data.forEach(function(item){
                        list += `<li><a href="${item.url}">${item.title}<span>See Details<svg width="0.375rem" height="0.625rem" viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><path xmlns="http://www.w3.org/2000/svg" stroke="black" stroke-linecap="round" stroke-linejoin="round" d="M0.643068 9L4.87689 5.27309C4.91558 5.23897 4.94657 5.197 4.9678 5.14998C4.98902 5.10296 5 5.05195 5 5.00036C5 4.94877 4.98902 4.89777 4.9678 4.85075C4.94657 4.80373 4.91558 4.76176 4.87689 4.72764L0.643067 1"/></svg></span></a></li>`;
                    });
                } else {
                    list = '<li>No results found</li>';
                }
                $('#venue-results').html(list);
            }
        });
    });

  const $input   = $('#venue-search');
  const $wrapper = $input.closest('.venue-search');
  const $results = $('#venue-results');

  // 1) Active class on focus/blur
  $input.on('focus', function () {
    $wrapper.addClass('active');
  });

  $input.on('blur', function () {
    $wrapper.removeClass('active');
  });

  // 2) Open class when there are results
  function updateOpenClass() {
    if ($results.children('li').length > 0) {
      $wrapper.addClass('open');
    } else {
      $wrapper.removeClass('open');
    }
  }

  // When typing (in case you build results synchronously)
  $input.on('input', updateOpenClass);

  // Observe async changes to #venue-results (e.g., after AJAX)
  if ($results.length) {
    new MutationObserver(updateOpenClass).observe($results[0], {
      childList: true
    });
  }

  // Optional: clicking outside closes everything
  $(document).on('mousedown', function (e) {
    if (!$(e.target).closest('.venue-search').length) {
      $wrapper.removeClass('active open');
    }
  });


});
